<template>
  <div class="home-fixed-investment" v-if="fixedProducts.length">
    <div class="section-title" v-if="$config.needElectronicContract">{{ $t('fundingOptions') }}</div>
    <div class="card investment">
      <div class="banner">
        <div class="banner-title">{{ currentProduct.name?currentProduct.name[locale]: '' }}</div>
        <div class="banner-content">
          <div class="banner-label">{{ $t('returnRateLabel') }}</div>
          <div class="banner-value">
            {{ currentProduct.interestPercent || 0}}%
            <span class="suffix">p.a.</span>
          </div>
          <div class="banner-label">{{ $t('termLabel') }}</div>
          <div class="banner-value term">
            {{ currentProduct.term }} {{$t('DAY')}}
          </div>
        </div>
      </div>
      <div class="invest-form">
        <div v-if="currentProduct.type !=='FIXED_TRIAL'" class="form-item">
          <div class="form-label">{{ $t('investAmountLabel') }}</div>
          <md-field>
            <md-input-item
              name="amount"
              type="money"
              maxlength="16"
              v-model="form.amount"
              class="input-money-container bordered"
              @change="delayExcute(1000, getRevenue)"
            >
              <cleave
                slot="left"
                v-model="form.amount"
                :placeholder="$t('amountPlaceholder')"
                :options="amountFormatOptions"
                class="input-money-inner"
              ></cleave>
            </md-input-item>
          </md-field>
        </div>
        <div class="form-item">
          <div class="form-label">{{ $t('durationLabel') }}</div>
          <div v-if="commonProductList.length > 0" class="product-list">
            <md-radio-list
              v-model="investedId"
              :options="commonProductList"
              icon=""
              icon-inverse=""
              icon-disabled=""
            ></md-radio-list>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label"> {{ $t('revenueLabel') }}</div>
          <div class="invest-revenue">
            {{ revenue | formatMoney}}
          </div>
        </div>
        <div class="form-item">
          <md-button type="primary" round class="btn-do" @click="goProduct('common', investedId)">
            {{ $t('doItNow') }}
          </md-button>
        </div>
      </div>
    </div>
    <div class="investment-plus" v-if="plusProductList.length">
      <div class="section-title">{{ $t('investmentVIP') }}</div>
      <div class="">
        <div v-for="item in plusProductList" :key="item.id" class="plus-card-wrap">
          <div class="plus-card" @click="goProduct('vip', item.id)">
            <div class="title"> {{ item.term }} {{ $t(item.dateUnit) }}</div>
            <div class="details">
              <div class="currency">{{ item.interestPercent }}%</div>
              <div class="desc">{{ $t('returnRateLabel') }}</div>
              <div class="tips">
                <span class="tip-money">Rp 1.000.000.000</span>
                <img class="coin" src="@/assets/image/investment/icon_input.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, InputItem, Field, RadioList } from 'mand-mobile'
import Cleave from 'vue-cleave-component'
import { amountOptions } from '@/lib/cleave'
import productMixin from '@/mixins/product'

export default {
  i18n: {
    messages: {
      en: {
        fundingOptions: 'Funding Options',
        fixedInvestmentTitle: 'Fixed Term Investment',
        minAmountLabel: 'Minimum Lending Amount Commitment',
        returnRateLabel: 'Return Projections',
        termLabel: 'Period of Lending',
        investAmountLabel: 'Your Total Lending Commitment',
        durationLabel: 'Period of Lending Commitment',
        revenueLabel: 'Projection of Your Funding Gains',
        amountPlaceholder: 'Please input Rupiah',
        doItNow: 'Start Funding',
        investmentVIP: 'Funding Options - VIP',
        DAY: 'Days', // 与返回字段dateUnit相关联
        MONTH: 'Month(s)',
        trialCard: 'Trial Card',
      },
      id: {
        fundingOptions: 'Pilihan Pendanaan',
        fixedInvestmentTitle: 'Pendanaan Berjangka',
        minAmountLabel: 'Jumlah Minimum Pendanaan',
        returnRateLabel: 'Proyeksi Keuntungan',
        termLabel: 'Period of Lending',
        investAmountLabel: 'Jumlah Pendanaan Anda',
        durationLabel: 'Jangka Waktu Pendanaan',
        revenueLabel: 'Proyeksi keuntungan pendanaan Anda',
        amountPlaceholder: 'Please input Rupiah',
        doItNow: 'Mulai Sekarang',
        investmentVIP: 'Pilihan Pendanaan - VIP',
        DAY: 'Hari',
        MONTH: 'Bulan',
        trialCard: 'Kartu Coba',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [RadioList.name]: RadioList,
    Cleave,
  },
  mixins: [productMixin],
  data() {
    return {
      currencyType: this.$store.state.currency,
      investedId: '',
      amount: '',
      amountFormatOptions: amountOptions,
    }
  },
  computed: {
    fixedProducts() {
      return this.$store.state.fixedProducts
    },
    trialProducts() {
      return this.$store.state.trialProducts
    },
    newProducts() {
      return this.$store.state.newProducts
    },
    commonProductList() {
      let newList = this.newProducts || []
      let trialList = this.trialProducts || []
      let fixedList = this.fixedProducts || []
      let commonList = []

      newList.sort((a, b) => a.term - b.term)
      commonList.push(...newList)

      trialList.sort((a, b) => a.term - b.term)
      commonList.push(...trialList)

      fixedList.sort((a, b) => a.term - b.term)
      fixedList = fixedList.filter(item => item.limitMinAmount < 1000000000)
      commonList.push(...fixedList)

      commonList.forEach(item => {
        item.text = `${item.term} ${this.$t(item.dateUnit)}`
        item.value = item.id
      })

      return commonList
    },
    plusProductList() {
      const list = this.fixedProducts
        .filter(item => item.limitMinAmount >= 1000000000)
        .sort((a, b) => a.term - b.term)
      return list || []
    },
    currentProduct() {
      const final = this.commonProductList.find(i => i.id === this.investedId)
      return final || {}
    },
    minInvestment() {
      return this.currentProduct.limitMinAmount || 0
    },
  },
  async mounted() {
    await this.$store.dispatch('reloadInvestments')
    this.updateInvestedId()
  },
  methods: {
    updateInvestedId() {
      if (this.trialProducts.length) {
        const maxRate = Math.max(...this.trialProducts.map(i => i.interestPercent))
        const trialProduct = this.trialProducts.find(i => i.interestPercent === maxRate)
        this.investedId = trialProduct.id
      } else if (this.newProducts.length) {
        const newMaxRate = Math.max(...this.newProducts.map(i => i.interestPercent))
        const newProduct = this.newProducts.find(i => i.interestPercent === newMaxRate)
        this.investedId = newProduct.id
      } else if (this.fixedProducts.length) {
        const maxInterestRate = Math.max(...this.commonProductList.map(i => i.interestPercent))
        const investment = this.fixedProducts.find(i => i.interestPercent === maxInterestRate)
        this.investedId = investment ? investment.id : ''
      }
    },
    goProduct(tag, investedId) {
      this.$router.push({
        path: '/product',
        query: {
          tag,
          investedId,
          amount: this.form.amount,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.home-fixed-investment {
  display: flex;
  flex-direction: column;
  padding: 30px 20px 0;
}

.banner {
  background-color: color-primary;
  color: #fff;
  border-radius: 6px 6px 0 0;
  .banner-title {
    padding: 15px 0 15px 30px;
    border-bottom: 1px solid #8dd75e;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
  }
  .banner-content {
    padding: 24px 30px;
    .banner-label {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 14px;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
    .banner-value {
      font-size: 40px;
      font-weight: bold;
      &.term {
        font-size: 25px;
      }
      .suffix {
        font-size: 20px;
      }
    }
  }
}

.invest-form {
  padding: 16px 12px;
  .form-item {
    .form-label {
      font-size: 12px;
      margin: 20px 0 10px;
    }
    &:first-child {
      .form-label {
        margin-top: 0;
      }
    }
  }
  .invest-revenue {
    font-size: 16px;
    font-weight: bold;
  }
  .btn-do {
    margin-top: 30px;
  }
}

.investment-plus {
  padding: 30px 16px 0;
  font-size: 16px;
  .plus-card-wrap {
    cursor: pointer;
    padding: 10px;
  }
  .plus-card {
    text-align: center;
    background: #fff;
    box-shadow: 0 7px 13px 0 rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    padding: 0;
    .title {
      color: #fff;
      background: url(../../assets/image/investment/invest-title-bg.png) no-repeat center center;
      background-size: 100% 100%;
      padding: 15px 40px;
      font-size: 22px;
    }
    .details {
      position: relative;
      overflow: hidden;
      padding-bottom: 40px;
      .currency {
        font-size: 43px;
        font-weight: bold;
        color: #101010;
        margin-top: 18px;
      }
      .desc {
        font-size: 14px;
        color: #333333;
        margin: 5px 0 25px 0;
      }
      .tips {
        border: 1px solid color-primary;
        border-radius: 16px;
        font-size: 10px;
        width: 90%;
        padding: 6px 0;
        margin: 0 auto;
        bottom: 20px;
        line-height: 20px;
        .tip-money {
          vertical-align: middle;
        }
        .coin {
          vertical-align: middle;
          margin-left: 0;
          width: 14px;
        }
      }
    }
  }
}

.product-list /deep/ {
  margin: 16px 0;
  .md-radio-list {
    text-align: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    .md-radio-item {
      width: 90px;
      margin: 0 4px 8px;
      color: #333;
      background: #eee;
      &.is-selected {
        color: #409020;
        background: rgba(184, 233, 134, 0.42);
        border-radius: 3px;
        opacity: 0.8733;
        border: 1px solid #409020;
      }
      .md-cell-item-body {
        padding: 0;
        min-height: 40px;
        .md-cell-item-left {
          margin: 0;
        }
        .md-cell-item-content {
          font-size: 14px;
        }
      }
    }
  }

  .md-radio-item .md-field-item-inner {
    padding: 14px 14px !important;
  }
  .md-field-item .md-field-item-inner::before {
    background-color: unset;
  }
  .md-field-item .md-field-item-content {
    justify-content: center;
  }
}

</style>
